import { ReactComponent as AmexLogo } from "@/assets/icons/amex.svg";
import { ReactComponent as MastercardLogo } from "@/assets/icons/mastercard-color.svg";
import { ReactComponent as VisaLogo } from "@/assets/icons/visa-color.svg";
import { Icon } from "@/components/atoms";
import { CardData, CardLabel, ClientPaymentMethod, PaymentMethodType } from "@/redux/apis/clientPayment/types";

/** Mirrors PaymentMethodKeysResource::MAX_CARDS_PER_ACCOUNT on the backend (DEV-1136) */
export const MAX_CARDS_PER_ACCOUNT = 5;

export const getCardBrandLogo = (issuer?: string) => {
  switch (issuer?.toLowerCase()) {
    case "visa":
      return <VisaLogo className="h-4 w-7" />;
    case "mastercard":
      return <MastercardLogo className="h-4 w-7" />;
    case "amex":
    case "american express":
      return <AmexLogo className="h-4 w-7" />;
    default:
      return <Icon name="Card" size={18} className="text-neutral-dark-gray" />;
  }
};

export const getCardIssuerDisplay = (issuer?: string) => {
  if (!issuer) return "Credit Card";
  if (issuer.toLowerCase() === "amex") return "American Express";
  return issuer.charAt(0).toUpperCase() + issuer.slice(1).toLowerCase();
};

export const getCardLabelDisplay = (label: CardLabel) => (label === CardLabel.CORPORATE ? "Business" : "Personal");

export const getCardLastFour = (cardData: CardData | null) => {
  const digits = cardData?.number?.replace(/\D/g, "") ?? "";
  return digits.slice(-4);
};

export const isCreditCard = (method: ClientPaymentMethod) => method.type === PaymentMethodType.CREDIT_CARD;

export const getCardNicknameDisplay = (method: ClientPaymentMethod) =>
  method.card_data?.nickname?.trim() || getCardIssuerDisplay(method.card_data?.issuer);

export const getCardExpiry = (cardData: CardData | null) => {
  if (!cardData?.expiry_month || !cardData?.expiry_year) return "";
  const mm = String(cardData.expiry_month).padStart(2, "0");
  const yy = String(cardData.expiry_year).slice(-2);
  return `${mm}/${yy}`;
};

export const isCardExpired = (cardData: CardData | null) => {
  if (!cardData?.expiry_year || !cardData?.expiry_month) return false;
  const now = new Date();
  const expiry = new Date(cardData.expiry_year, cardData.expiry_month, 1); // first day after expiry month
  return now >= expiry;
};
